import theme from "theme";

import Text from "components/Text";

import { IApplicationField } from "entities/Application/sdk";
import InstructionsDialogButton from "entities/Field/components/InstructionsDialogButton";

export interface IFieldTitle {
  field: IApplicationField;
}

const FieldTitle = ({ field }: IFieldTitle) => (
  <Text
    variant="text2"
    sx={{
      fontWeight: 500,
      paddingRight: theme.spacing(2),
    }}
    maxWidth="60%"
  >
    {field.name}
    <InstructionsDialogButton
      internalInstructions={field?.internal_instructions}
      externalInstructions={field?.external_instructions}
      sx={{
        paddingTop: theme.spacing(0.5),
        display: "inline-flex",
        marginLeft: theme.spacing(0.5),
      }}
    />
  </Text>
);

export default FieldTitle;
